module.exports = __webpack_public_path__ + "img/bl-back.86727ec7.png";